export const GroupStatus = Object.freeze({
    EDITING: "editing",
    APPLIED: "applied",
})
